// 🚨 Know your side effects before using this... 🚨
//
// iOS can get a tendency to lock the keyboard x px when the user unblurs. The
// process to get unstuck is a convoluted since the user needs to scroll the
// viewport.
//
// But using this quirk makes this never be an issue but.
export function quirk_iOSKeyboardLockBodyScroll(): void {
	globalThis.scrollY = 0;
	globalThis.scrollBy(0, 0);

	requestAnimationFrame(() => {
		globalThis.scrollY = 0;
		globalThis.scrollBy(0, 0);
	});
}
